import { Card, CardContent, Typography, Grid } from "@mui/material";
import { BeneficiaryInfo } from "../../../../interfaces/DTO/mislaka_xml_insurence_models";
import { formatIsoDate, formatPercentage } from "../../../../utils/namesFormater";
import { formatBeneficiaryIdentificationType, formatBeneficiaryDefinition, formatBeneficiaryType, formatRelationType, formatBeneficiaryIDCode } from "../../../../utils/pensionEnumFormatter";

interface FieldDef<T> {
  field: keyof T;
  label: string;
  format?: (value: any) => string | number;
}

const beneficiaryFieldDefs: FieldDef<BeneficiaryInfo>[] = [
  { field: 'identification_type', label: 'סוג זיהוי', format: formatBeneficiaryIdentificationType },
  { field: 'id_code', label: 'קוד זיהוי',format:formatBeneficiaryIDCode },
  { field: 'id_number', label: 'מספר זיהוי' },
  { field: 'first_name', label: 'שם פרטי' },
  { field: 'last_name', label: 'שם משפחה' },
  { field: 'birth_date', label: 'תאריך לידה', format: formatIsoDate },
  { field: 'relation_type', label: 'סוג זיקה', format: formatRelationType },
  { field: 'beneficiary_percentage', label: 'אחוז מוטב', format:formatPercentage },
  { field: 'definition', label: 'הגדרה', format: formatBeneficiaryDefinition },
  { field: 'beneficiary_nature', label: 'מהות מוטב', format: formatBeneficiaryType },
];

interface BeneficiaryInfoCardProps {
  beneficiary: BeneficiaryInfo;
}

export const BeneficiaryInfoCard: React.FC<BeneficiaryInfoCardProps> = ({ beneficiary }) => {
  return (
    <Card className="rounded-2xl shadow-md p-4">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          פרטי מוטב
        </Typography>
        <Grid container spacing={2}>
          {beneficiaryFieldDefs.map(({ field, label, format }) => {
            const value = beneficiary[field];
            if (value == null || value === '') return null;
            const display = format ? format(value) : value;
            return (
              <Grid item xs={12} sm={6} key={field as string}>
                <strong>{label}:</strong> {display}
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
    </Card>
  );
};